import { getLocationsTimeSlotsInfo } from './booking/getLocationsTimeSlotsInfo';

async function prepareDrSmileApiLocations(allLocationsApiLocations, serviceCode) {
  // fetch the new available slots info from BE and update all the locations
  const newLocations = await getLocationsTimeSlotsInfo(allLocationsApiLocations.nodes, serviceCode);

  return {
    nodes: newLocations.map(location => {
      const a = {
        ...location,
        image: { gatsbyImageData: location.image.childImageSharp?.gatsbyImageData || null },
        service: {
          ...location.service,
          ...location.services?.find(service => service.code === serviceCode),
        },
      };
      delete a.services;
      return a;
    }),
  };
}

export default prepareDrSmileApiLocations;
